<!-- Main container -->
<div class="layout-col full">
  <!-- Search Component -->
  <elder-table
    class="flex"
    matSort
    [data]="workStations$ | async"
    [idField]="'id'"
    [selectionMultiEnabled]="true"
    [selectionVisible]="true"
  >
    <elder-data-toolbar
      *elderTableToolbar
      (requestRemove)="onRemove($event)"
      [canRemove]="true"
      [canAdd]="true"
      [canMore]="false"
    >
      <ng-template [elderToolbarContent]="'left'">
        <mat-form-field>
          <elder-select
            appWorkStationSelect
            [facilityId]="facilityId"
            (valueChange)="onAdd($event)"
            [disabledWorkStations]="workStations$ | async"
          >
            <div *elderSelectValue="let value" class="layout-col">
              <span class="text-body-medium">{{ value.number }} {{ value.name }}</span>
              <span class="text-body-small">{{ value.description }}</span>
            </div>
          </elder-select>
        </mat-form-field>
      </ng-template>
    </elder-data-toolbar>

    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">{{ ws?.number }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">{{ ws?.name }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 50%" mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">
        <div class="layout-col place-center-start">
          <span class="mat-body-2">{{ ws?.description }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef style="width: 20%" mat-sort-header>
        {{ 'context.type' | translate }}
      </th>
      <td mat-cell *matCellDef="let ws">{{ ws?.type?.name }}</td>
    </ng-container>
  </elder-table>
</div>
